import { createSlice } from '@reduxjs/toolkit';

export interface ReportState {
  LastUpdated: string
}

const initialState: ReportState = {
  LastUpdated: ''
};

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setLastUpdated: (state: ReportState) => {
      const date = new Date(); 
      state.LastUpdated = `${date.toLocaleDateString()} - ${date.toLocaleTimeString()}`; 
    },
  }
});

export const { setLastUpdated } = reportSlice.actions;
export default reportSlice.reducer;
